import React, { useContext, startTransition } from 'react';
import { MdClose } from 'react-icons/md';
import { NavLinks } from '../../data/content';
import Logo from '../../shared/Logo/Logo';
import { useNavigate } from 'react-router-dom';
import CartContext from '../../context/CartContext';

const NavMobile = ({ onClickClose }) => {
  const { event } = useContext(CartContext);
  const navigate = useNavigate();
  const links = [...NavLinks];

  // Si hay un evento activo, lo insertamos en la lista de links
  if (event.name) {
    links.splice(3, 0, {
      id: 'ee46s',
      name: event.name,
      href: event.href,
    });
  }

  // Navegación dentro de startTransition
  const handleNavigate = (href) => {
    startTransition(() => {
      navigate(href);
      onClickClose(); // cerrar el menú
    });
  };

  return (
    <div className="h-screen w-full divide-y divide-neutral-300 overflow-y-auto py-2 bg-black shadow-lg ring-1 transition">
      <div className="px-5 py-2 relative">
        <Logo className="block" />
        <span
          className="absolute right-2 top-2 p-2 w-4 h-4 cursor-pointer"
          onClick={onClickClose}
        >
          <MdClose className="w-7 h-7" />
        </span>
      </div>

      <ul className="flex flex-col space-y-5 px-5 py-6">
        {links.map((item) => (
          <li key={item.id}>
            <button
              onClick={() => handleNavigate(item.href)}
              className="capitalize text-left bg-transparent border-0 cursor-pointer text-white hover:text-gray-300"
            >
              {item.name}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default NavMobile;
